module.exports = __webpack_public_path__ + "img/dash-card-bg-3.ac20a1fa.svg";